<template>
  <v-dialog lazy v-model="dialog" width="700">
    <v-toolbar color="teal" dark>
      <v-toolbar-title>Últimas atualizações</v-toolbar-title>
    </v-toolbar>

    <v-list>
      <v-list-group v-for="item in items" v-model="item.active" :key="item.version" prepend-icon="play_arrow" no-action>
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title> <span class="version">Versão {{ item.version }}</span> - {{ item.date }} </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-card wrap justify-center align-center v-for="change in item.changes" :key="change.title">
          <v-card-text>
            <v-textarea style="text-align: justify" v-html="'<ul><li><h4>' + change.title  + '</h4>' + change.details + '</li></ul>'"></v-textarea>
          </v-card-text>
        </v-card>
      </v-list-group>
    </v-list>
  </v-dialog>
</template>

<style scoped>
  .version {
    font-weight: bold;
  }
</style>

<script>
  export default {
    data () {
      return {
        dialog: false
      }
    },
    computed: {
      items: function () {
        return [
          {
            version: '0.0.1',
            date: '05/02/2019',
            active: true,
            changes: [
              {
                title: 'Por dentro dos acontecimentos nas tarefas',
                details: 'Foi acidionado uma nova aba para que todas as alterações feitas nas tarefas sejam registradas e você sempre saiba se alguma coisa mudou.'
              },
              {
                title: 'Saiba de tudo',
                details: 'Implementamos as notificações. Sempre que acontecer algo importante, você será avisado.'
              },
              {
                title: 'Mesmo offline, não perca nada',
                details: 'Mesmo se você não estiver online para ser notificado, todas as suas notificações estarão no novo quadro da tela principal.'
              }
            ]
          }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PChangeLog.vue